// Stores with city and pincode relationships
export const stores = [
    // Mumbai stores
    { id: 'STR-MUM-001', name: 'ABIS Fort', cityId: 'CITY-MUM', pincode: '400001', area: 'Fort', delayFactor: 0.08 },
    { id: 'STR-MUM-002', name: 'ABIS Andheri', cityId: 'CITY-MUM', pincode: '400058', area: 'Andheri West', delayFactor: 0.12 },
    { id: 'STR-MUM-003', name: 'ABIS Bandra', cityId: 'CITY-MUM', pincode: '400050', area: 'Bandra', delayFactor: 0.10 },
    { id: 'STR-MUM-004', name: 'ABIS Thane', cityId: 'CITY-MUM', pincode: '400601', area: 'Thane', delayFactor: 0.15 },

    // Delhi stores
    { id: 'STR-DEL-001', name: 'ABIS Connaught', cityId: 'CITY-DEL', pincode: '110001', area: 'Connaught Place', delayFactor: 0.10 },
    { id: 'STR-DEL-002', name: 'ABIS Saket', cityId: 'CITY-DEL', pincode: '110017', area: 'Saket', delayFactor: 0.09 },
    { id: 'STR-DEL-003', name: 'ABIS Dwarka', cityId: 'CITY-DEL', pincode: '110075', area: 'Dwarka', delayFactor: 0.18 },
    { id: 'STR-DEL-004', name: 'ABIS Gurgaon', cityId: 'CITY-DEL', pincode: '122001', area: 'Gurgaon', delayFactor: 0.14 },

    // Bangalore stores
    { id: 'STR-BLR-001', name: 'ABIS Koramangala', cityId: 'CITY-BLR', pincode: '560034', area: 'Koramangala', delayFactor: 0.07 },
    { id: 'STR-BLR-002', name: 'ABIS Indiranagar', cityId: 'CITY-BLR', pincode: '560038', area: 'Indiranagar', delayFactor: 0.08 },
    { id: 'STR-BLR-003', name: 'ABIS Whitefield', cityId: 'CITY-BLR', pincode: '560066', area: 'Whitefield', delayFactor: 0.16 },

    // Hyderabad stores
    { id: 'STR-HYD-001', name: 'ABIS Banjara Hills', cityId: 'CITY-HYD', pincode: '500034', area: 'Banjara Hills', delayFactor: 0.09 },
    { id: 'STR-HYD-002', name: 'ABIS Hitech City', cityId: 'CITY-HYD', pincode: '500081', area: 'Hitech City', delayFactor: 0.11 },
    { id: 'STR-HYD-003', name: 'ABIS Gachibowli', cityId: 'CITY-HYD', pincode: '500032', area: 'Gachibowli', delayFactor: 0.13 },

    // Chennai stores
    { id: 'STR-CHN-001', name: 'ABIS T.Nagar', cityId: 'CITY-CHN', pincode: '600017', area: 'T.Nagar', delayFactor: 0.10 },
    { id: 'STR-CHN-002', name: 'ABIS Anna Nagar', cityId: 'CITY-CHN', pincode: '600040', area: 'Anna Nagar', delayFactor: 0.12 },
    { id: 'STR-CHN-003', name: 'ABIS Velachery', cityId: 'CITY-CHN', pincode: '600042', area: 'Velachery', delayFactor: 0.14 },

    // Pune stores
    { id: 'STR-PUN-001', name: 'ABIS Koregaon Park', cityId: 'CITY-PUN', pincode: '411001', area: 'Koregaon Park', delayFactor: 0.09 },
    { id: 'STR-PUN-002', name: 'ABIS Kothrud', cityId: 'CITY-PUN', pincode: '411014', area: 'Kothrud', delayFactor: 0.11 },
    { id: 'STR-PUN-003', name: 'ABIS Hinjewadi', cityId: 'CITY-PUN', pincode: '411027', area: 'Hinjewadi', delayFactor: 0.15 },

    // Kolkata stores
    { id: 'STR-KOL-001', name: 'ABIS Park Street', cityId: 'CITY-KOL', pincode: '700001', area: 'Park Street', delayFactor: 0.12 },
    { id: 'STR-KOL-002', name: 'ABIS Salt Lake', cityId: 'CITY-KOL', pincode: '700020', area: 'Salt Lake', delayFactor: 0.10 },
    { id: 'STR-KOL-003', name: 'ABIS New Town', cityId: 'CITY-KOL', pincode: '700091', area: 'New Town', delayFactor: 0.14 },

    // Ahmedabad stores
    { id: 'STR-AMD-001', name: 'ABIS CG Road', cityId: 'CITY-AMD', pincode: '380001', area: 'CG Road', delayFactor: 0.11 },
    { id: 'STR-AMD-002', name: 'ABIS SG Highway', cityId: 'CITY-AMD', pincode: '380015', area: 'SG Highway', delayFactor: 0.09 },
    { id: 'STR-AMD-003', name: 'ABIS Prahlad Nagar', cityId: 'CITY-AMD', pincode: '380054', area: 'Prahlad Nagar', delayFactor: 0.13 },
];

// Get unique pincodes
export const pincodes = [...new Set(stores.map(s => s.pincode))].map(code => {
    const store = stores.find(s => s.pincode === code);
    return {
        code,
        cityId: store.cityId,
        area: store.area,
    };
});

// Helper functions
export function getStoresByCity(cityIds) {
    if (!cityIds || cityIds.length === 0) return stores;
    return stores.filter(store => cityIds.includes(store.cityId));
}

export function getStoresByPincode(pincodeCodes) {
    if (!pincodeCodes || pincodeCodes.length === 0) return stores;
    return stores.filter(store => pincodeCodes.includes(store.pincode));
}

export function getPincodesByCity(cityIds) {
    if (!cityIds || cityIds.length === 0) return pincodes;
    return pincodes.filter(pin => cityIds.includes(pin.cityId));
}

export function getPincodesByStores(storeIds) {
    if (!storeIds || storeIds.length === 0) return pincodes;
    const storePincodes = stores
        .filter(store => storeIds.includes(store.id))
        .map(store => store.pincode);
    return pincodes.filter(pin => storePincodes.includes(pin.code));
}

export function getStoreById(storeId) {
    return stores.find(store => store.id === storeId);
}

export function getStoreName(storeId) {
    const store = getStoreById(storeId);
    return store ? store.name : 'Unknown';
}

export function getPincodeArea(code) {
    const pin = pincodes.find(p => p.code === code);
    return pin ? `${pin.code} - ${pin.area}` : code;
}

export function getStoresByCityId(cityId) {
    return stores.filter(store => store.cityId === cityId);
}

export default stores;
